import React from "react"

export default class Icon extends React.Component {
	icons = {
		"arrow-down":
			"M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z",
		"arrow-up":
			"M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z",
		"arrow-left":
			"M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z",
		"arrow-right": "M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z",
		attach:
			"M7 4v12.434c0 .636.28 1.239.765 1.649l3.598 3.043c.368.311.907.311 1.274 0l3.599-3.043c.485-.41.764-1.013.764-1.649v-13.934c0-.276-.224-.5-.5-.5h-5c-.276 0-.5.224-.5.5v9.697c0 .229.091.448.253.61l.513.513c.129.129.339.129.469 0l.513-.513c.161-.161.252-.381.252-.61v-7.197h2v7.585c0 .531-.211 1.04-.586 1.415l-1.707 1.707c-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-1.707-1.707c-.375-.375-.586-.884-.586-1.415v-10.585c0-1.104.896-2 2-2h6c1.104 0 2 .896 2 2v14.606c0 1.162-.508 2.265-1.39 3.021l-4.715 4.042c-.257.22-.577.331-.895.331-.319 0-.638-.111-.896-.332l-4.714-4.041c-.883-.756-1.39-1.859-1.39-3.021v-12.606h2z"
	}

	constructor(props) {
		super(props)

		this.state = {
			icon:
				this.props.name && this.icons[this.props.name]
					? this.icons[this.props.name]
					: "",
			width: this.props.width || "1rem",
			height: this.props.height || "1rem"
		}
	}

	render() {
		const { width, height, icon } = this.state
		return (
			<svg
				className={this.props.className}
				xmlns="http://www.w3.org/2000/svg"
				width={width}
				height={height}
				viewBox="0 0 24 24"
			>
				<path fill="currentColor" d={icon} />
			</svg>
		)
	}
}



// WEBPACK FOOTER //
// /home/christian/git/pwa-crc806db/src/components/Icon/index.js